import React from 'react';

interface ReedemFormProps {
  submitCallback: (name: string, password: string, code: string) => void;
  onValidError: (error: string) => void;
  errorText: string | null;
  disableRegistration: boolean;
};

const RedeemForm: React.FC<ReedemFormProps> = (props) => {
    let nameRef = React.createRef<HTMLInputElement>();
    let passwordRef = React.createRef<HTMLInputElement>();
    let codeRef = React.createRef<HTMLInputElement>();
    let formRef = React.createRef<HTMLFormElement>();

    const error = props.errorText
      ? <div className="failure">{props.errorText}</div>
      : null;

    return (
      <div className="form_container">
  
        <h3>Reward Bundle</h3>
      
        {error}

        <form ref={formRef}>

          <div className="form-group row">
            <label
              className="col align-self-center"
              htmlFor="red_code_input">Reward Bundle code</label>
            <input className="form-control col-9" ref={codeRef} type="text"
                id="red_code_input"
                placeholder="code"
                required/>
          </div>

          <h3>Enter Star Realms Account Information</h3>
			<p>If you need to verify your username, you can see it at the top of the Play Online screen in the app.</p>
          <div className="form-group row">
            <label
              className="col align-self-center"
              htmlFor="username_input">Username</label>         
            <input className="form-control col-9" ref={nameRef} type="text"
              id="username_input"
              placeholder="username, not email address"
              required
              pattern="^[A-Za-z][A-Za-z0-9]{2,11}"/>
          </div>
  
          <div className="form-group row">
            <label
              className="col align-self-center"
              htmlFor="password_input">Password</label>
            <input className="form-control col-9" ref={passwordRef} type="password"
                id="password_input"
                placeholder="password"
                required/>
          </div>

          <div className="form-group row">
            <span className="col align-self-center smalltext"><a href="https://srprodv2.whitewizardgames.com/account/forgotpassword" target="_blank" rel="noreferrer">Forgot Password?</a></span>
          </div>
  
          <button 
            type="button" className="btn btn-primary"
            disabled={props.disableRegistration}
            onClick={e => {
                if (formRef.current?.reportValidity()) {
                  
                  props.submitCallback(
                    nameRef.current!.value,
                    passwordRef.current!.value,
                    codeRef.current!.value);
                }
              }}>Redeem</button>        

        </form>
  
      </div>);
  }

export default RedeemForm;
